// extracted by mini-css-extract-plugin
export var component = "hosted-video-module--component--cWyiQ";